import { AncillariesBundleConfig } from '../../../../AncillariesBundles';

export const splitBundlesByIncluded = (
  bundles: AncillariesBundleConfig[],
): {
  bundlesWithoutIncluded: AncillariesBundleConfig[];
  bundlesWithIncluded: AncillariesBundleConfig[];
} => {
  const bundlesWithoutIncluded: AncillariesBundleConfig[] = [];
  const bundlesWithIncluded: AncillariesBundleConfig[] = [];

  for (const item of bundles) {
    if (item.items.every((subItem) => !subItem.included)) {
      bundlesWithoutIncluded.push(item);
    } else {
      bundlesWithIncluded.push(item);
    }
  }

  return { bundlesWithoutIncluded, bundlesWithIncluded };
};
